import { NgModule } from '@angular/core';
import { AccountsFilterComponent } from './accounts-list/users-filter/users-filter.component';
import { AccountsListComponent } from './accounts-list/accounts-list.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConfirmModalModule, ErrorContainerModule, InputTextModule, TableModule, ValidatedInputFieldModule } from 'ccc-commons/core';
import { NgbDatepickerModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UserModalModule } from '../../components/user-modal/user-modal.module';
import { OrgFloatingMenuComponent } from '../../components/org-floating-menu/org-floating-menu.component';
import { SharedModule } from '../../shared.module';
import { UserLicenseModalComponent } from './license-modal/license-modal.component';
import { EmailModalModule } from 'src/app/shared/modules/accounts/email-modal/email-modal.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    NgbDatepickerModule,
    ErrorContainerModule,
    ValidatedInputFieldModule,
    ConfirmModalModule,
    TableModule,
    UserModalModule,
    SharedModule,
    NgbTooltipModule,
    EmailModalModule
  ],
  declarations: [
    AccountsListComponent,
    AccountsFilterComponent,
    OrgFloatingMenuComponent,
    UserLicenseModalComponent
  ],
  exports: [
    AccountsListComponent,
    AccountsFilterComponent,
    OrgFloatingMenuComponent,
    UserLicenseModalComponent
  ]
})
export class AccountsModule {}
